/**
 * @deprecated since v 10.0.0: replaced by knora-api-js-lib
 *
 */
export * from './api-service-result';
export * from './api-service-error';
export * from './api/operators';
export * from './utils';

/**
 * @deprecated since v 10.0.0: replaced by knora-api-js-lib
 *
 * Interfaces for constants and operators
 */
export * from './api/knora-constants';

/**
 * Interfaces for resources
 */
export * from './api/v2/representations/region';

